import styled from 'styled-components';

export const CustomerListContainer = styled.div`
    #header {
        height: 50px;
        background-color: #3a5b77;
        padding-top: 13px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    #form {
        height: 178px;
        background-color: #c8e0ed;
        font-family: Lato;
        padding: 5px 15px;
        text-align: left;
        font-size: 12px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .search-data {
        height: 100%;
        margin: 0em;
        overflow-y: auto;
    }
`;